var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"errorBox"},[_c('img',{staticClass:"errorImg",attrs:{"src":require("@/assets/error/404.png"),"alt":"404"}}),_c('h2',{staticClass:"title"},[_vm._v("该页面不存在")])])])
}]

export { render, staticRenderFns }